/* eslint-disable import/prefer-default-export */
export const transactionItem = {
    box: 'relative flex justify-between items-center flex-row-reverse p-12 mb-0 lg:mb-12 border border-solid border-bluegray-300 rounded-8',
    adName: "text-14 font-normal mb-0 truncate",
    actionLink: "font-bold mb-0 text-gray-700 hover:no-underline",
    adImg: "rounded-8 shadow w-48 h-48",
    notificationDot: "rounded-full shadow bg-red-400 border-white border-2 border-solid w-16 h-16 absolute -top-4 -right-4",
};
